import styles from './FeaturesLayout.scss';
import equal from 'fast-deep-equal/react';
import MainFeaturesLayout from '~/Layouts/Features/Views/MainFeaturesLayout/MainFeaturesLayout';
import { useAppSelector } from '~/Store';

interface IFeaturesLayout {
    shipId: number;
}

const FeaturesLayout = ({ shipId }: IFeaturesLayout) => {
    const shipFeatureMap = useAppSelector((state) => state.features.shipFeatureMap, equal);
    const currentFeature = shipFeatureMap[shipId];

    if (!currentFeature) return null;

    return (
        <div className={styles.features}>
            {currentFeature.categories.map((categories, key) => {
                if (!categories.features.every((feature) => feature.title)) {
                    return null;
                }
                return (
                    <div className={styles.feature} key={key}>
                        <div className={styles.featureIcon} style={{ backgroundImage: `url(${categories.category.icons.default})` }} />
                        <div className={styles.featureContent}>
                            <div className={styles.featureTitle}>{categories.category.title}</div>
                            <MainFeaturesLayout features={categories.features} className={styles.featureLine} circleSize={styles.featureCircle} detailedFeatures={true} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FeaturesLayout;
